module.exports = __webpack_public_path__ + "img/home-04.1df57254.jpg";